import { summarizeError, toErrorReport } from './errorReport.js';
export const defaultErrorLogger = (event) => {
    console.log('[layerswap:log]', toErrorReport(event));
};
export function reportErrorLoggerFailure(event, error) {
    console.error('[layerswap/widget] onError callback failed; falling back to console logging.', summarizeError(error));
    defaultErrorLogger(event);
}
/** Recursion guard and failure fallback; `event` is already a public report. */
function createGuardedLogger(handler) {
    let isHandlingError = false;
    return (event) => {
        if (isHandlingError) {
            reportErrorLoggerFailure(event, new Error('Recursive onError callback invocation blocked'));
            return;
        }
        isHandlingError = true;
        try {
            handler(event);
        }
        catch (error) {
            reportErrorLoggerFailure(event, error);
        }
        finally {
            isHandlingError = false;
        }
    };
}
/** Shared by standalone package consumers and the widget's registration store. */
export function createSafeErrorLogger(handler) {
    const guarded = createGuardedLogger(handler);
    return (event) => guarded(toErrorReport(event));
}
let deliver = defaultErrorLogger;
let classify;
export function setErrorLogger(logger) {
    deliver = createGuardedLogger(logger);
}
/** Independent of setErrorLogger: replacing the destination never drops classification. */
export function setErrorClassifier(classifier) {
    classify = classifier;
}
export function ErrorHandler(event) {
    // Classification and identity use the original error. Only the public report leaves here.
    let reasonCode;
    try {
        reasonCode = classify?.(event);
    }
    catch { /* Optional classification cannot break execution. */ }
    const report = toErrorReport(event);
    if (report.reasonCode === undefined && reasonCode !== undefined)
        report.reasonCode = reasonCode;
    return deliver(report);
}
